import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ObjectId } from 'bson';

import { FieldKinds, TableCellKinds } from '@site-mate/dashpivot-shared-library';

import { TableDisplayModes } from 'app/form-fields/table/template/table-display-modes';
import { FieldWeb } from 'app/shared/model/item.model';

import { TableCellService } from './service/table-cell.service';
import { FormulaBarService } from '../formula-bar/formula-bar.service';

@Component({
  selector: 'cc-table-type-switch',
  templateUrl: './table-type-switch.component.html',
  styleUrls: ['./table-type-switch.component.scss', '../../../common/template/form-control.component.scss'],
})
export class TableTypeSwitchComponent {
  @Input() model: FieldWeb;
  @Input() hierarchy: string;
  @Input() identifier: number;

  @Output() changed = new EventEmitter();

  tableTypes = [
    { type: FieldKinds.Table, title: 'Default' },
    { type: FieldKinds.PrefilledTable, title: 'Prefilled' },
  ];

  constructor(
    private readonly formulaBarService: FormulaBarService,
    private readonly tableCellService: TableCellService,
  ) {}

  private convertToTable(model: FieldWeb) {
    model.id = new ObjectId().toHexString();
    model.kind = FieldKinds.Table;
    model.displayRowsMode = TableDisplayModes.defaultMode().key;

    model.columns = this.cloneRowColumnsToColumns(model);

    delete model.rows;
  }

  private cloneRowColumnsToColumns(model: FieldWeb) {
    return model.rows[0].columns.map((rowColumn, index) => {
      const currentColumn = model.columns[index];
      return this.tableCellService.clonePrefilledToDefaultCell(currentColumn, rowColumn);
    });
  }

  private convertToPrefilledTable(model: FieldWeb) {
    model.id = new ObjectId().toHexString();
    model.kind = FieldKinds.PrefilledTable;
    model.displayRowsMode = TableDisplayModes.defaultMode().key;
    model.columns = model.columns.filter((column) => column.kind !== TableCellKinds.ListProperty);

    model.rows = [{ columns: this.cloneColumnsToRowColumns(model) }];
  }

  private cloneColumnsToRowColumns(model: FieldWeb) {
    return model.columns.map((columnCell) => {
      return this.tableCellService.cloneDefaultToPrefilledCell(columnCell);
    });
  }

  onChange(kind: FieldKinds) {
    const fieldKindsFunctions = {
      [FieldKinds.Table]: () => this.convertToTable(this.model),
      [FieldKinds.PrefilledTable]: () => this.convertToPrefilledTable(this.model),
    };

    fieldKindsFunctions[kind]();

    this.formulaBarService.closeFormulaBar({ tableId: this.model.id });
    this.changed.emit();
  }
}
